/** Max decimals shown when precision is unset/0 so fractional values are not truncated. */
const AUTO_MAX_FRACTION_DIGITS = 6;
/** Compact notation stays short — do not reuse the full auto max. */
const COMPACT_AUTO_MAX_FRACTION_DIGITS = 1;

/**
 * Precision 0 (default) keeps integers clean but still shows decimals when present.
 * Explicit precision > 0 locks both min and max fraction digits.
 * @param options.compact — use a tighter max so K/M/B stay abbreviated (e.g. 1.2M not 1.234567M).
 */
export function resolveNumberFractionDigits(
	precision: number,
	options?: { compact?: boolean }
): {
	minimumFractionDigits: number;
	maximumFractionDigits: number;
} {
	const safePrecision =
		typeof precision === 'number' && Number.isFinite(precision)
			? Math.max(0, Math.trunc(precision))
			: 0;
	if (safePrecision > 0) {
		return {
			minimumFractionDigits: safePrecision,
			maximumFractionDigits: safePrecision,
		};
	}
	return {
		minimumFractionDigits: 0,
		maximumFractionDigits: options?.compact
			? COMPACT_AUTO_MAX_FRACTION_DIGITS
			: AUTO_MAX_FRACTION_DIGITS,
	};
}
